window.HH = window.HH || {}

window.HH.enableQuickview = function enableQuickview({
	fullURL,
	shortURL,
} = {}) {
	console.log(fullURL, shortURL)
	if (!fullURL && !shortURL) return

	const drawer = document.getElementById('Product-Drawer')
	const body = document.body
	let href = null

	if (fullURL) {
		let url = new URL(fullURL)
		url.searchParams.append('view', 'quick-view')
		href = `${url.pathname}${url.search}`
	} else if (shortURL) {
		href = `${shortURL}?view=quick-view`
	}

	fetch(href, {
		method: 'GET',
	})
		.then((response) => {
			if (!response.ok) {
				window.location.href = href
				throw new Error('Network response was not ok')
			}
			return response.text()
		})
		.then((text) => {
			const sectionInnerHTML = new DOMParser()
				.parseFromString(text, 'text/html')
				.querySelector('#Product-Drawer-Content').innerHTML
			window.HH.renderQuickview(sectionInnerHTML, drawer, body, href)
		})
		.catch((e) => {
			console.error(e)
		})
}

window.HH.renderQuickview = function (sectionInnerHTML, drawer, body, href) {
	if (sectionInnerHTML) {
		drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML

		setTimeout(() => {
			if (Shopify && Shopify.PaymentButton) {
				Shopify.PaymentButton.init()
			}
		}, 300)
		body.classList.add('open-cc')
		body.classList.add('open-quick-view')
		drawer.classList.add('active')
		setTimeout(() => {
			drawer
				.querySelector('.product-quick-images--container')
				.classList.add('active')
		})
		drawer.querySelector('.side-panel-close').focus()
		dispatchCustomEvent('quick-view:open', {
			drawer: drawer,
			productUrl: href,
		})
	}
}
